import React, {Component} from "react";
import {
    GetBillwerkAccountByOwner,
    GetBillwerkledgerEntriesByLoggedInAccountId,
    GetCustomerInvoices,
    UpdateBillwerkCustomerAddress
} from "../PremiumService";
import './PremiumType.scss';
import {withToast} from "../../../util/ToastService";
import Strings from "../../../config/Strings";
import GlobalConstants from "../../../config/GlobalConstants";
import {Col, Form, Row, Table} from "react-bootstrap";
import {TigerSpinner} from "../../../global/tiger-spinner/TigerSpinner";
import {FunctionalModal} from "../../../global/ConfirmationModal";
import {BiCheck} from "react-icons/bi";

class ShopSubscriptionAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accountId: props.accountId,
            contract: props.contract,
            cancellationAllowed: props.contract != null && props.contract.EndDate == null &&
                props.subscription != null && props.subscription.articleId != null && props.subscription.articleId.indexOf("tigerticket") < 0,
            customer: {Address: {}},
            updatedCustomer: {Address: {}},
            paymentData: (props.contract != null && props.contract.PaymentBearer != null) ? props.contract.PaymentBearer : null,
            invoices: [],
            ledgerEntries: [],
            loading: true,
            editCustomer: false
        }
    }

    async componentDidMount() {
        await this.loadInvoices();
    }

    async loadInvoices() {

        let ledgerEntriesRes = await GetBillwerkledgerEntriesByLoggedInAccountId();

        let invoicesRes = await GetCustomerInvoices(null);
        if (!invoicesRes.error) {
            let customer = {Address: {}};
            if (this.state.accountId) {
                let customerRes = await GetBillwerkAccountByOwner(this.state.accountId);
                if (!customerRes && !customerRes.error) {
                    customer = customerRes.result;
                    if (!customer.Address) {
                        customer.Address = {};
                    }
                }
            }
            this.setState(prevState => ({
                ...prevState,
                ledgerEntries: ledgerEntriesRes?.result,
                invoices: invoicesRes.result.filter(i => (i.details != null && i.details.downloadUrl != null)),
                customer: customer,
                updatedCustomer: customer,
                loading: false
            }))
        } else {
            this.setState(prevState => ({...prevState, loading: false}));
        }
    }

    async updateBillwerkCustomer() {
        let updatedCustomer = this.state.customer;
        if (updatedCustomer.Address != null && (updatedCustomer.Address.Country == null || updatedCustomer.Address.Country === "")) {
            updatedCustomer.Address.Country = "DE";
        }

        let response = await UpdateBillwerkCustomerAddress(this.state.accountId, this.state.updatedCustomer);
        if (!response.error) {
            this.setState(prevState => ({
                ...prevState,
                customer: response.result,
                updatedCustomer: response.result,
                editCustomer: false
            }));
        } else {
            this.props.addToast("Beim Ändern der Daten ist leider ein Fehler aufgetreten", {autoDismiss: true, appearance: "error"});
        }
    }

    isCreditCard() {
      return (this.state.paymentData && this.state.paymentData.Type != null && this.state.paymentData.Type === "CreditCard");
    }

    isSepa() {
        return (this.state.paymentData && this.state.paymentData.Type != null && this.state.paymentData.Type === "BankAccount");
    }

    isPaypal() {
        return (this.state?.paymentData?.Type === "PayPal");
    }

    getCcValidity() {
        const month = this.state.paymentData && this.state.paymentData.ExpiryMonth;
        const year = this.state.paymentData && this.state.paymentData.ExpiryYear;
        if (month && year) {
            return month + "/" + year;
        } else {
            return null;
        }
    }

    getValueOrPlaceholder(originalString, value, placeholder = "-") {
        if (value != null && value.trim() !== "") {
            return (<><strong>{originalString}</strong>{value}</>);
        } else {
            return (<><strong>{originalString}</strong>{placeholder}</>);
        }
    }

    getCountryName() {
        if (this.state.customer == null || this.state.customer.Address == null || this.state.customer.Address.Country == null) {
            return null;
        }

        if (this.state.customer.Address.Country === "DE") {
            return Strings.PURCHASE_COUNTRY_DE;
        } else if (this.state.customer.Address.Country === "AT") {
            return Strings.PURCHASE_COUNTRY_AT;
        } else if (this.state.customer.Address.Country === "CH") {
            return Strings.PURCHASE_COUNTRY_CH;
        } else {
            return null;
        }
    }

    openSelfService() {
        this.props.history.push("/" + GlobalConstants.APP_PATH + "premium/settings")
    }


    customerIsValid() {
        if (this.state.customer == null || this.state.updatedCustomer == null) {
            return true;
        }

        //If the previous customer had an adress, the updated one should have one to
        if (this.state.customer.Address != null) {
            const address = this.state.customer.Address;
            const updatedAddress = this.state.updatedCustomer.Address;
            if (address.Street != null && (updatedAddress.Street == null || updatedAddress.Street === "")) {
                return false;
            } else if (address.HouseNumber != null && (updatedAddress.HouseNumber == null || updatedAddress.HouseNumber === "")) {
                return false;
            } else if (address.PostalCode != null && (updatedAddress.PostalCode == null || updatedAddress.PostalCode === "")) {
                return false;
            } else if (address.City != null && (updatedAddress.City == null || updatedAddress.City === "")) {
                return false;
            }
        }
        if (this.state.customer.FirstName != null && (this.state.updatedCustomer.FirstName == null || this.state.updatedCustomer.FirstName === "")) {
            return false;
        } else if (this.state.customer.LastName != null && (this.state.updatedCustomer.LastName == null || this.state.updatedCustomer.LastName === "")) {
            return false;
        } else if (this.state.customer.EmailAddress != null && (this.state.updatedCustomer.EmailAddress == null || this.state.updatedCustomer.EmailAddress === "")) {
            return false;
        }
        return true;
    }

    render() {
        return (
            <>
                <div className="premium-type-container">
                    {this.state.loading &&
                        <TigerSpinner/>
                    }
                    {!this.state.loading &&
                    <div>
                        {this.state.ledgerEntries?.length > 0 &&
                        <>
                            <div className="content-header premium-type-header"
                                 style={{color: '#6c757d'}}>{Strings.PREMIUM_INVOICES_LABEL}</div>
                            <div className="premium-type-table">
                                <Table striped>
                                    <thead>
                                    <tr>
                                        <th>{Strings.PREMIUM_TYPE_TABLE_HEADER_DATE}</th>
                                        <th>{Strings.PREMIUM_TYPE_TABLE_HEADER_CONTRACT}</th>
                                        <th>{Strings.PREMIUM_TYPE_TABLE_HEADER_DESCRIPTION}</th>
                                        <th>{Strings.PREMIUM_TYPE_TABLE_HEADER_TYPE}</th>
                                        <th>{Strings.PREMIUM_TYPE_TABLE_HEADER_STATE}</th>
                                        <th>{Strings.PREMIUM_TYPE_TABLE_HEADER_AMOUNT}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.ledgerEntries?.map(item => (
                                        <tr role="row" key={item.id}>
                                            <td data-label={Strings.PREMIUM_TYPE_TABLE_HEADER_DATE}>{new Date(item.Timestamp).toLocaleDateString()}</td>
                                            <td data-label={Strings.PREMIUM_TYPE_TABLE_HEADER_CONTRACT}>{item.ContractName}</td>
                                            <td data-label={Strings.PREMIUM_TYPE_TABLE_HEADER_DESCRIPTION}>{item.Description}</td>
                                            <td data-label={Strings.PREMIUM_TYPE_TABLE_HEADER_TYPE}>{item.Type}</td>
                                            <td data-label={Strings.PREMIUM_TYPE_TABLE_HEADER_STATE}>{item.PaymentStatus ? item.PaymentStatus : "offen"}</td>
                                            <td data-label={Strings.PREMIUM_TYPE_TABLE_HEADER_AMOUNT} className={"column-amount"}>{item.Amount.toLocaleString() + " " + item.Currency}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </div>
                        </>
                        }
                        {this.state.cancellationAllowed &&
                        <div>
                            <a href={GlobalConstants.URL_CANCEL_CONTRACTS}
                               style={{color: "#ce023e"}}>{Strings.PREMIUM_SHOW_CANCEL_CONTRACT}&#187;</a>
                        </div>
                        }
                    </div>
                    }
                </div>
                <FunctionalModal
                    title={Strings.PURCHASE_EDIT_CUSTOMER_TITLE}
                    show={this.state.editCustomer}
                    actionButtonLabel={<><BiCheck/>{Strings.PROFILES_DETAILS_SAVE_BUTTON}</>}
                    actionButtonVariant="red"
                    onActionPress={() => this.updateBillwerkCustomer()}
                    actionDisabled={!this.customerIsValid()}
                    onHide={() => this.setState(prevState => ({
                        ...prevState,
                        editCustomer: false,
                        updatedCustomer: this.state.customer
                    }))}
                >
                    {this.editCustomerDialog()}
                </FunctionalModal>
            </>
        );
    }


    editCustomerDialog() {
        if (this.state.updatedCustomer == null) {
            return <></>
        }

        return (
            <Form>
                <Form.Group className="mb-3">
                    <Form.Label>{Strings.PURCHASE_CONTACT_FIRSTNAME}</Form.Label>
                    <Form.Control onChange={(e) => this.setState(prevState => ({
                                      ...prevState,
                                      updatedCustomer: {
                                          ...prevState.updatedCustomer,
                                          FirstName: e.target.value
                                      }}))}
                                  value={this.state.updatedCustomer.FirstName}/>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>{Strings.PURCHASE_CONTACT_LASTNAME}</Form.Label>
                    <Form.Control onChange={(e) => this.setState(prevState => ({
                        ...prevState,
                        updatedCustomer: {
                            ...prevState.updatedCustomer,
                            LastName: e.target.value
                        }}))}
                                  value={this.state.updatedCustomer.LastName}/>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>{Strings.PURCHASE_CONTACT_EMAIL}</Form.Label>
                    <Form.Control onChange={(e) => this.setState(prevState => ({
                        ...prevState,
                        updatedCustomer: {
                            ...prevState.updatedCustomer,
                            EmailAddress: e.target.value
                        }}))}
                                  value={this.state.updatedCustomer.EmailAddress}/>
                </Form.Group>
                <Row>
                    <Form.Group as={Col} className="mb-3">
                        <Form.Label>{Strings.PURCHASE_CONTACT_STREET}</Form.Label>
                        <Form.Control onChange={(e) => this.setState(prevState => ({
                            ...prevState,
                            updatedCustomer: {
                                ...prevState.updatedCustomer,
                                Address: {
                                    ...prevState.updatedCustomer.Address,
                                    Street: e.target.value
                                }
                            }}))}
                                      value={this.state.updatedCustomer.Address.Street}/>
                    </Form.Group>
                    <Form.Group as={Col} className="mb-3">
                        <Form.Label>{Strings.PURCHASE_CONTACT_HOUSE_NO}</Form.Label>
                        <Form.Control onChange={(e) => this.setState(prevState => ({
                            ...prevState,
                            updatedCustomer: {
                                ...prevState.updatedCustomer,
                                Address: {
                                    ...prevState.updatedCustomer.Address,
                                    HouseNumber: e.target.value
                                }
                            }}))}
                                      value={this.state.updatedCustomer.Address.HouseNumber}/>
                    </Form.Group>
                </Row>
                <Row>
                    <Form.Group as={Col} className="mb-3">
                        <Form.Label>{Strings.PURCHASE_CONTACT_POSTAL_CODE}</Form.Label>
                        <Form.Control onChange={(e) => this.setState(prevState => ({
                            ...prevState,
                            updatedCustomer: {
                                ...prevState.updatedCustomer,
                                Address: {
                                    ...prevState.updatedCustomer.Address,
                                    PostalCode: e.target.value
                                }
                            }}))}
                                      value={this.state.updatedCustomer.Address.PostalCode}/>
                    </Form.Group>
                    <Form.Group as={Col} className="mb-3">
                        <Form.Label>{Strings.PURCHASE_CONTACT_CITY}</Form.Label>
                        <Form.Control onChange={(e) => this.setState(prevState => ({
                            ...prevState,
                            updatedCustomer: {
                                ...prevState.updatedCustomer,
                                Address: {
                                    ...prevState.updatedCustomer.Address,
                                    City: e.target.value
                                }
                            }}))}
                                      value={this.state.updatedCustomer.Address.City}/>
                    </Form.Group>
                </Row>
                <Form.Group className="mb-3">
                    <Form.Label>{Strings.PURCHASE_CONTACT_COUNTRY}</Form.Label>
                    <Form.Control
                        as="select"
                        required
                        value={this.state.updatedCustomer.Address.Country}
                        onChange={(e) => this.setState(prevState => ({
                            ...prevState,
                            updatedCustomer: {
                                ...prevState.updatedCustomer,
                                Address: {
                                    ...prevState.updatedCustomer.Address,
                                    Country: e.target.value
                                }
                            }}))}
                    >
                        <option value="DE">{Strings.PURCHASE_COUNTRY_DE}</option>
                        <option value="CH">{Strings.PURCHASE_COUNTRY_CH}</option>
                        <option value="AT">{Strings.PURCHASE_COUNTRY_AT}</option>
                    </Form.Control>
                </Form.Group>
            </Form>
        )
    }
}

export default withToast(ShopSubscriptionAccess);